export const SET_CHECKOUT_PRIVACY_CONSENT = 'SET_CHECKOUT_PRIVACY_CONSENT';
export const INITIAL_CHECKOUT_PRIVACY_CONSENT = 'INITIAL_CHECKOUT_PRIVACY_CONSENT';
export const SET_IS_CHECKOUT_PRIVACY_CONSENT_TOUCHED = 'SET_IS_CHECKOUT_PRIVACY_CONSENT_TOUCHED';
